import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { throwError } from "rxjs";
import { catchError, map } from "rxjs/operators";

import { environment } from "environments/environment";
import { Innovation } from "../models";
import { PagedData } from "@core/models/datables";
import { AdvancedSearch } from "@ryd/models/advanced-search";

@Injectable({ providedIn: "root" })
export class InnovationService {
  /**
   *
   * @param _http
   */
  constructor(private _http: HttpClient) {}

  /**
   * Gets a list of all innovations without filters
   * @returns List of innovations
   */
  getInnovations() {
    return this._http.get<Innovation[]>(
      `${environment.innovationApiUrl}/api/innovation`
    );
  }

  /**
   * Get all Innovations
   *
   */
  getAll(page: number, quantity: number, sortColumn) {
    return this._http.post<PagedData<Innovation>>(
      `${environment.innovationApiUrl}/api/innovation/page/${page}/${quantity}`,
      sortColumn
    );
  }

  getAllByProviderId(
    page: number,
    quantity: number,
    providerId: number,
    sortColumn
  ) {
    return this._http.post<PagedData<Innovation>>(
      `${environment.innovationApiUrl}/api/innovation/page/${providerId}/${page}/${quantity}`,
      sortColumn
    );
  }

  addInnovation(innovation) {
    return this._http
      .post<Innovation>(
        `${environment.innovationApiUrl}/api/innovation`,
        innovation
      )
      .pipe(
        map((response: any) => response.innovation as Innovation),
        catchError((e) => {
          return throwError(e);
        })
      );
  }

  editInnovation(innovation: Innovation) {
    return this._http
      .put<Innovation>(
        `${environment.innovationApiUrl}/api/innovation/${innovation.id}`,
        innovation
      )
      .pipe(
        map((response: any) => response.innovation as Innovation),
        catchError((e) => {
          return throwError(e);
        })
      );
  }

  search(page: number, quantity: number, search: AdvancedSearch) {
    return this._http.post<PagedData<Innovation>>(
      `${environment.innovationApiUrl}/api/innovation/search/${page}/${quantity}`,
      search
    );
  }

  deleteById(id: string) {
    return this._http.put<any>(
      `${environment.innovationApiUrl}/api/innovation/delete/${id}`,
      null
    );
  }

  getAllKeywords(name: string){
    return this._http.get<Innovation[]>(`${environment.innovationApiUrl}/api/innovation/keywords/${name}`);
  }
}
